<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-form v-model="valid" lazy-validation ref="form" v-if="theme">
          <v-card-text>
            <v-container grid-list-xl fluid>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="theme.name" label="Name" />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-checkbox label="Dark" v-model="theme.dark" />
                </v-flex>
                <v-flex xs12 sm3>
                  Acccent color
                  <ChromePicker
                    :value="theme.accentColor"
                    @input="color => (theme.accentColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Background color
                  <ChromePicker
                    :value="theme.backgroundColor"
                    @input="color => (theme.backgroundColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Bottom app bar color
                  <ChromePicker
                    :value="theme.bottomAppBarColor"
                    @input="color => (theme.bottomAppBarColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Button color
                  <ChromePicker
                    :value="theme.buttonColor"
                    @input="color => (theme.buttonColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Canvas color
                  <ChromePicker
                    :value="theme.canvasColor"
                    @input="color => (theme.canvasColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Card color
                  <ChromePicker
                    :value="theme.cardColor"
                    @input="color => (theme.cardColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Cursor color
                  <ChromePicker
                    :value="theme.cursorColor"
                    @input="color => (theme.cursorColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Dialog background color
                  <ChromePicker
                    :value="theme.dialogBackgroundColor"
                    @input="color => (theme.dialogBackgroundColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Disabled color
                  <ChromePicker
                    :value="theme.disabledColor"
                    @input="color => (theme.disabledColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Divider color
                  <ChromePicker
                    :value="theme.dividerColor"
                    @input="color => (theme.dividerColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Error color
                  <ChromePicker
                    :value="theme.errorColor"
                    @input="color => (theme.errorColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Highlight color
                  <ChromePicker
                    :value="theme.highlightColor"
                    @input="color => (theme.highlightColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Hint color
                  <ChromePicker
                    :value="theme.hintColor"
                    @input="color => (theme.hintColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Indicator color
                  <ChromePicker
                    :value="theme.indicatorColor"
                    @input="color => (theme.indicatorColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Primary color
                  <ChromePicker
                    :value="theme.primaryColor"
                    @input="color => (theme.primaryColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Primary color dark
                  <ChromePicker
                    :value="theme.primaryColorDark"
                    @input="color => (theme.primaryColorDark = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Primary color light
                  <ChromePicker
                    :value="theme.primaryColorLight"
                    @input="color => (theme.primaryColorLight = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Scaffold background color
                  <ChromePicker
                    :value="theme.scaffoldBackgroundColor"
                    @input="
                      color => (theme.scaffoldBackgroundColor = color.hex)
                    "
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Secondary header color
                  <ChromePicker
                    :value="theme.secondaryHeaderColor"
                    @input="color => (theme.secondaryHeaderColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Selected row color
                  <ChromePicker
                    :value="theme.selectedRowColor"
                    @input="color => (theme.selectedRowColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Splash color
                  <ChromePicker
                    :value="theme.splashColor"
                    @input="color => (theme.splashColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Text selection color
                  <ChromePicker
                    :value="theme.textSelectionColor"
                    @input="color => (theme.textSelectionColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Text selection handle color
                  <ChromePicker
                    :value="theme.textSelectionHandleColor"
                    @input="
                      color => (theme.textSelectionHandleColor = color.hex)
                    "
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Toggleable active color
                  <ChromePicker
                    :value="theme.toggleableActiveColor"
                    @input="color => (theme.toggleableActiveColor = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Unselected widget color
                  <ChromePicker
                    :value="theme.unselectedWidgetColor"
                    @input="color => (theme.unselectedWidgetColor = color.hex)"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider />
            <v-container grid-list-xl fluid>
              <v-layout wrap>
                <v-flex xs12>
                  <v-subheader class="title">Color scheme</v-subheader>
                </v-flex>
                <v-flex xs12 sm3>
                  Background
                  <ChromePicker
                    :value="theme.colorScheme.background"
                    @input="color => (theme.colorScheme.background = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Error
                  <ChromePicker
                    :value="theme.colorScheme.error"
                    @input="color => (theme.colorScheme.error = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  On background
                  <ChromePicker
                    :value="theme.colorScheme.onBackground"
                    @input="
                      color => (theme.colorScheme.onBackground = color.hex)
                    "
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  On error
                  <ChromePicker
                    :value="theme.colorScheme.onError"
                    @input="color => (theme.colorScheme.onError = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  On primary
                  <ChromePicker
                    :value="theme.colorScheme.onPrimary"
                    @input="color => (theme.colorScheme.onPrimary = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  On secondary
                  <ChromePicker
                    :value="theme.colorScheme.onSecondary"
                    @input="
                      color => (theme.colorScheme.onSecondary = color.hex)
                    "
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  On surface
                  <ChromePicker
                    :value="theme.colorScheme.onSurface"
                    @input="color => (theme.colorScheme.onSurface = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Primary
                  <ChromePicker
                    :value="theme.colorScheme.primary"
                    @input="color => (theme.colorScheme.primary = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Primary variant
                  <ChromePicker
                    :value="theme.colorScheme.primaryVariant"
                    @input="
                      color => (theme.colorScheme.primaryVariant = color.hex)
                    "
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Secondary
                  <ChromePicker
                    :value="theme.colorScheme.secondary"
                    @input="color => (theme.colorScheme.secondary = color.hex)"
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Secondary variant
                  <ChromePicker
                    :value="theme.colorScheme.secondaryVariant"
                    @input="
                      color => (theme.colorScheme.secondaryVariant = color.hex)
                    "
                  />
                </v-flex>
                <v-flex xs12 sm3>
                  Surface
                  <ChromePicker
                    :value="theme.colorScheme.surface"
                    @input="color => (theme.colorScheme.surface = color.hex)"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="!valid"
              color="primary"
              :loading="loading"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { Chrome } from "vue-color";
import { db } from "../../plugins/firebase";
import { theme, eventHub } from "../../config/constants";

export default {
  name: "Themes",
  components: {
    ChromePicker: Chrome
  },
  data: () => ({
    valid: false,
    loading: false,
    theme: null
  }),
  firestore: {
    theme: db.collection("themes").doc(theme)
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.set(this.$firestoreRefs.theme, this.theme)
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
